import { call, put, select,takeLatest } from "redux-saga/effects";
import { DayOff, Holiday, WorkingTime } from 'src/components';

import { API } from "../../api";
import {
  createSchedule,
  createScheduleFailure,
  createScheduleSuccess,
  getFilteredSchedules,
  getFilteredSchedulesFailure,
  getFilteredSchedulesSuccess,
  getSchedules,
  getSchedulesFailure,
  getSchedulesSuccess,
  removeSchedule,
  removeScheduleFailure,
  removeScheduleSuccess,
  updateSchedule,
  updateScheduleFailure,
  updateScheduleSuccess,
} from "../reducers/schedulesSlice";

import { errorHandler } from "./common";

function* getSchedulesSaga () {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, "/schedule-templates", {
      params: {
        limit: '500',
      },
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(getSchedulesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: getSchedulesSaga,
      *callback () {
        yield put(getSchedulesFailure(error));
      },
    });
  }
}

function* getFilteredSchedulesSaga (action: any) {
  try {
    const searchParams = action.payload;
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, "/schedule-templates", {
      params: {
        ...searchParams,
      },
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(getFilteredSchedulesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getFilteredSchedulesSaga(action);
      },
      *callback () {
        yield put(getFilteredSchedulesFailure(error));
      },
    });
  }
}

interface createScheduleSagaProp {
  payload: {
    title: string;
    description: string;
    workingTimes: Array<WorkingTime>;
    daysOff: Array<DayOff>,
    holidays: Array<Holiday>,
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* createScheduleSaga ({
  payload: {
    title,
    description,
    workingTimes,
    daysOff,
    holidays,
    onSuccess,
    onFailure,
  },
}: createScheduleSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      "/schedule-templates",
      {
        title,
        description,
        workingTimes,
        daysOff,
        holidays,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );
    yield put(createScheduleSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: createScheduleSaga,
      *callback () {
        yield put(createScheduleFailure(error));
        onFailure(error);
      },
    });
  }
}

interface updateScheduleSagaProp {
  payload: {
    title: string;
    description: string;
    workingTimes: Array<WorkingTime>;
    daysOff: Array<DayOff>,
    holidays: Array<Holiday>,
    currentId: number;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* updateScheduleSaga ({
  payload: {
    title,
    description,
    workingTimes,
    daysOff,
    holidays,
    currentId,
    onSuccess,
    onFailure,
  },
}: updateScheduleSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.put,
      `/schedule-templates/${currentId}`,
      {
        title,
        description,
        workingTimes,
        daysOff,
        holidays,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(updateScheduleSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: updateScheduleSaga,
      *callback () {
        yield put(updateScheduleFailure(error));
        onFailure(error);
      },
    });
  }
}

interface removeScheduleSagaProp {
  payload: {
    currentId: number;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* removeScheduleSaga ({
  payload: { currentId, onSuccess, onFailure },
}: removeScheduleSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.delete, `/schedule-templates/${currentId}`, {
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(removeScheduleSuccess(response.data));
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: removeScheduleSaga,
      *callback () {
        yield put(removeScheduleFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* schedulesSaga () {
  // @ts-ignore
  yield takeLatest(getSchedules().type, getSchedulesSaga);
  // @ts-ignore
  yield takeLatest(getFilteredSchedules().type, getFilteredSchedulesSaga);
  // @ts-ignore
  yield takeLatest(createSchedule().type, createScheduleSaga);
  // @ts-ignore
  yield takeLatest(updateSchedule().type, updateScheduleSaga);
  // @ts-ignore
  yield takeLatest(removeSchedule().type, removeScheduleSaga);
}
